
import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from '@mui/icons-material/Close';
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import InfoIcon from "@mui/icons-material/Info";
import theme from '../../../src/theme';
import { Box } from "@mui/material";

export const typeConfig = {
  Success: {
    icon: <CheckCircleIcon />,
    color: "success.main",
    bg: theme.palette.success?.lighter,
    border: "success.main",
    textColor: '#2F854B'
  },
  Warning: {
    icon: <WarningAmberIcon />,
    color: "warning.main",
    bg: theme.palette.warning?.lighter,
    border: "warning.main",
    textColor: "#A36100"
  },
  Failed: {
    icon: <Box
      sx={{
        bgcolor: theme.palette.error.main,
        color: "#fff",
        borderRadius: "50%",
        width: 16,
        height: 16,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CloseIcon sx={{ fontSize: 16 }} />
    </Box>,
    color: "error.main",
    bg: theme.palette.error?.lighter,
    border: "error.main",
    textColor: "#D34142"
  },
  Info: {
    icon: <InfoIcon />,
    color: "info.main",
    bg: theme.palette.primary.lighter,
    border: "info.main",
    textColor: "#0077B7"
  },
};